<div class="slider-item admin-playlist-card-container"
  [ngClass]="{'slider-item-selector': !slidItemClass}"
  (click)="playlistClick(playlists)">
  <div class="slider-img" [attr.playlist-slug]="playlists.slug" lazy-load-images (click)="playlistClick(playlists);">
    <img alt="playlists.title" [src]="playlists.playlist_image" onError="this.src='https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png'">
    <span *ngIf="type === 'favorite'" class="like-box" (click)="favourite(video, $event)">
      <i [ngClass]="'liked'"></i>
    </span>
    <span class="total-videos">{{playlists.playlist_videos_count}} {{ 'ADMIN_PLAYLIST.VIDEOS' | translate }}</span>
  </div>
  <div class="slider-content">
    <h3 class="category-text" (click)="playlistClick(playlists);">
      {{playlists?.name}}
    </h3>
  </div>
</div>
